export const menuTranslations = {
  ar: {
    dashboard: 'لوحة التحكم',
    companies: 'الشركات',
    branches: 'الفروع',
    customers: 'العملاء',
    vendors: 'الموردين',
    stores: 'المخازن',
    inventory: 'المخزون',
    accounts: 'الحسابات',
    chartOfAccounts: 'دليل الحسابات',
    journal: 'القيود',
    items: 'البنود',
    invoices: 'الفواتير',
    pos: 'نقطة البيع',
    taxes: 'الضرائب',
    taxReports: 'تقارير الضرائب',
    reports: 'التقارير',
    users: 'المستخدمين',
    settings: 'الإعدادات',
    customersVendors: 'العملاء والموردين',
    salesOrders: 'طلبات البيع',
    purchaseInvoices: 'فواتير الشراء',
    landedCosts: 'تكاليف إضافية على المشتريات',
    purchaseReturns: 'مرتجعات الشراء',
    salesReturns: 'مرتجعات البيع',
    accountTransfer: 'تحويل الحسابات',
    budgets: 'الميزانيات',
    costCenters: 'مراكز التكلفة',
    categories: 'التصنيفات',
    currencies: 'العملات',
    fiscalYears: 'السنوات المالية',
    operationTypes: 'أنواع العمليات',
    roles: 'الأدوار',
    permissions: 'الصلاحيات',
    loyalty: 'نظام الولاء',
    webhooks: 'Webhooks',
    generalAttributes: 'الخصائص العامة',
    salesReps: 'مندوبي المبيعات',
    shifts: 'الورديات',
  },
  en: {
    dashboard: 'Dashboard',
    companies: 'Companies',
    branches: 'Branches',
    customers: 'Customers',
    vendors: 'Vendors',
    stores: 'Stores',
    inventory: 'Inventory',
    accounts: 'Accounts',
    chartOfAccounts: 'Chart of Accounts',
    journal: 'Journal',
    items: 'Items',
    invoices: 'Invoices',
    pos: 'POS',
    taxes: 'Taxes',
    taxReports: 'Tax Reports',
    reports: 'Reports',
    users: 'Users',
    settings: 'Settings',
    customersVendors: 'Customers & Vendors',
    salesOrders: 'Sales Orders',
    purchaseInvoices: 'Purchase Invoices',
    landedCosts: 'Landed Costs',
    purchaseReturns: 'Purchase Returns',
    salesReturns: 'Sales Returns',
    accountTransfer: 'Account Transfer',
    budgets: 'Budgets',
    costCenters: 'Cost Centers',
    categories: 'Categories',
    currencies: 'Currencies',
    fiscalYears: 'Fiscal Years',
    operationTypes: 'Operation Types',
    roles: 'Roles',
    permissions: 'Permissions',
    loyalty: 'Loyalty',
    webhooks: 'Webhooks',
    generalAttributes: 'General Attributes',
    salesReps: 'Sales Reps',
  },
  fr: {
    dashboard: 'Tableau de bord',
    companies: 'Entreprises',
    branches: 'Succursales',
    customers: 'Clients',
    vendors: 'Fournisseurs',
    stores: 'Magasins',
    inventory: 'Inventaire',
    accounts: 'Comptes',
    chartOfAccounts: 'Plan comptable',
    journal: 'Journal',
    items: 'Articles',
    invoices: 'Factures',
    pos: 'PDV',
    taxes: 'Taxes',
    taxReports: 'Rapports fiscaux',
    reports: 'Rapports',
    users: 'Utilisateurs',
    settings: 'Paramètres',
    customersVendors: 'Clients et Fournisseurs',
    salesOrders: 'Commandes de vente',
    purchaseInvoices: 'Factures d\'achat',
    landedCosts: 'Coûts additionnels d\'achat',
    purchaseReturns: 'Retours d\'achat',
    salesReturns: 'Retours de vente',
    accountTransfer: 'Transfert de compte',
    budgets: 'Budgets',
    costCenters: 'Centres de coût',
    categories: 'Catégories',
    currencies: 'Devises',
    fiscalYears: 'Exercices fiscaux',
    operationTypes: 'Types d\'opérations',
    roles: 'Rôles',
    permissions: 'Autorisations',
    loyalty: 'Fidélité',
    webhooks: 'Webhooks',
    generalAttributes: 'Attributs généraux',
    salesReps: 'Représentants commerciaux',
    shifts: 'Quarts de travail',
  },
}


